import {Link} from 'react-router-dom';
import styles from './MenuItem.module.scss';
import cls from 'classnames';
import React from "react";
import {noop} from "lodash";
const MenuItem = ({icon, text, href, active = false, onClick = noop}) => {
    if (href) {
        return (
            <Link to={href} className={cls(styles.menuItem, {[styles.active]: active})}>
                {React.cloneElement(icon, {className: styles.icon})}
                <span className={styles.label}>{text}</span>
            </Link>
        );
    }
    return (
        <div className={cls(styles.menuItem, {[styles.active]: active})} onClick={onClick}>
            {React.cloneElement(icon, {className: styles.icon})}
            <span className={styles.label}>{text}</span>
        </div>
    );
}

export default MenuItem;
